import { all } from "axios";

export default {
  startsWith: 'Starts with',
  contains: 'Contains',
  notContains: 'Not contains',
  endsWith: 'Ends with',
  equals: 'Equals',
  notEquals: 'Not equals',
  noFilter: 'No Filter',
  lt: 'Less than',
  lte: 'Less than or equal to',
  gt: 'Greater than',
  gte: 'Greater than or equal to',
  dateIs: 'Date is',
  dateIsNot: 'Date is not',
  dateBefore: 'Date is before',
  dateAfter: 'Date is after',
  custom: 'Custom',
  clear: 'Clear',
  apply: 'Apply',
  matchAll: 'Match All',
  matchAny: 'Match Any',
  addRule: 'Add Rule',
  removeRule: 'Remove Rule',
  accept: 'Yes',
  reject: 'No',
  choose: 'Choose',
  upload: 'Upload',
  cancel: 'Cancel',
  dayNames: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  monthNames: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  monthNamesShort: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ],
  today: 'Today',
  weekHeader: 'Wk',
  firstDayOfWeek: 0,
  dateFormat: 'yyyy-mm-dd',
  weak: 'Weak',
  medium: 'Medium',
  strong: 'Strong',
  passwordPrompt: 'Enter a password',
  emptyFilterMessage: 'No results found',
  emptyMessage: 'No available options',
  uploadedFiles: 'Uploaded files',
  uploadFailed: 'Upload Failed',
  maxFileLimit: 'Max file limit of ${limit} exceeded!',
  assignBoxOrContainer: 'Assign box or container',
  loadingCandidates: 'Loading candidates...',
  selectCandidate: 'Select',
  useContainerInstead: 'Use container instead',
  containerIdentifierPlaceholder: 'e.g. CONT-12345',
  noCandidatesFoundModal: 'No access requests/boxes matching the condition were found.',
  confirm: 'Confirm',
  aria: {
    trueLabel: 'True',
    falseLabel: 'False',
    nullLabel: 'Not Selected',
    slideNumber: 'Slide {slideNumber}',
    pageLabel: 'Page',
    firstPageLabel: 'First Page',
    lastPageLabel: 'Last Page',
    nextPageLabel: 'Next Page',
    previousPageLabel: 'Previous Page',
    selectLabel: 'Select',
    unselectLabel: 'Unselect',
    expandLabel: 'Expand',
    collapseLabel: 'Collapse',
  },
  validations: {
    required: 'Value is required.',
    undefined: 'Value is required.',
    email: 'Value is not a valid email address',
    minLength: 'This field should be at least ${min} characters long',
    maxLength: 'The maximum length allowed is ${max}',
    minValue: 'The minimum value allowed is ${min}',
    maxValue: 'The maximum value allowed is ${max}',
    numeric: 'Value must be numeric',
    ipAddress: 'The value is not a valid IP address',
    sameAs: 'The value must be equal to the ${otherName} value',
    alpha: 'Value must contain only letters',
    alphaNum: 'Value must contain only letters and numbers',
    between: 'Value must be between ${min} and ${max}',
    length: 'Length must be ${length} characters',
    pattern: 'Value does not match the required pattern',
    url: 'Value is not a valid URL',
    integer: 'Value must be an integer',
    minItems: 'Select at least ${min} items',
    maxItems: 'You cannot select more than ${max} items',
  },
  company: 'Company',
  company_name: 'Company Name',
  visitant: 'Visitor',
  visitant_name: 'Visitor Name',
  visitante_name: 'Visitor Name',
  visitant_email: 'Visitor Email',
  visitant_phone: 'Visitor Phone',
  phone: 'Phone',
  reason: "Reason",
  visit_to: 'Visit To',
  select_to: 'Select Who to Visit',
  date_to_visit: 'Date of Visit',
  time_to_visit: 'Time of Visit',
  identification: 'Identification',
  officialIdentification: "Official identification number",
  Indentifications: "(INE, Driver's License, Passport)",
  Indentifications2: "(Driver's License, Passport)",
  fmmNumber: "FMM Number",
	fmmNumberPlaceholder: "Enter the official identification number (Driver's License, Passport)",
	fmmFormatExample: "Format: 9-15 alphanumeric characters",
	fmmRequired: "Official identification is required for foreigners",
	fmmRequiredToAccess: "Official identification is required for foreign access",
	ineRequiredToAccess: "Official identification is required for Mexican citizens",
	ineNumberPlaceholder: "Enter the official identification number",
	ineFormatExample: "13 digits",
	ineRequired: "Official identification is required for Mexican citizens",
	seeFmmExample: "See official identification example",
	fmmExampleTitle: "Official Identification Example",
	fmmHelp: "This is the accepted official identification for foreigners:",
	fmmExampleAlt: "Ejemplo de numero de identificación oficial",
	fmmTooltipText: "Find the number on your official identification document",
	validationError: "Validation error",
	imageNotAvailable: "Image not available",
	identificationExampleTitle: "Official Identification Example",
	identificationHelp: "Here you can see an example of where to find your official identification number:",
  identificationExampleAlt: "Official INE Identification Example",
  imageNotAvailable: "Image not available",
  ineTooltipText: "INE: Enter the 13 digits at the bottom of your credential.",
  seeIdentificationExample: "See official identification example",
  idIneLabel: "INE - Voter Credential",
  idIneAlt: "INE Example - Front",
  idDriverLicenseLabel: "Driver's License",
  idDriverLicenseAlt: "Driver's License Example",
  idPassportLabel: "Passport",
  idPassportAlt: "Passport Example",
  fmmCardLabel: "Passport - Front",
  fmmCardAlt: "FMM Example - Card",
  fmmVisaLabel: "Driver's License - Front",
  fmmVisaAlt: "Driver's License Example",
  fmmDocumentLabel: "Immigration Document FMM",
  fmmDocumentAlt: "Immigration Document Example",
  save: 'Save',
  submit: 'Submit',
  info_not_permitted:
    'This access is exclusively for visitors. Engaging in operational activities, such as construction, site work, maintenance, or material delivery, is strictly prohibited under this permit.',
  show_security_rules: 'Show security rules',
  visitors: 'Visitors',
  carriers: 'Carriers',
  carriersDashboard: 'Operational carriers dashboard',
  dashboard: 'Dashboard',
  carrierOperations: 'Operations',
  carrierCatalogs: 'Catalogs',
  carrierLogs: 'Logs',
  carrierMap: 'Truck Yard',
  carriersMap: 'Truck Yard',
  carriersDashboardLabels: {
    title: "Operational carriers dashboard",
    todayLabel: 'Today "Date: ${date}"',
    rangeCurrent: "Current range: ${range}",
    rangeLabel: "View by",
    dateRangeLabel: "Date range",
    apply: "Apply",
    clear: "Clear",
    viewList: "View list",
    driverIngressTitle: "Driver entry",
    visitsTitle: "Carrier visits",
    avgInspectionTitle: "Average inspection times",
    emptyChart: "No data for the selected range",
    emptyVisits: "No visits registered",
    emptyTable: "No records found for the selected filters.",
    range: {
      day: "Day",
      week: "Week",
      month: "Month",
      year: "Year",
    },
    legend: {
      export: "Export",
      import: "Import",
      empty: "Empty",
      return: "Return",
    },
    summary: {
      requests: "Carrier requests",
      exports: "Exports in progress",
      locals: "Locals in progress",
      imports: "Imports in progress",
      returns: "Returns in progress",
    },
    inspections: {
      done: "Inspections completed",
      locals: "Locals",
      backups: "Backups",
      returns: "Returns",
      exports: "Exports",
      imports: "Imports",
      secondReview: "Second review",
      rejected: "Rejected inspections",
    },
    drivers: {
      local: "Local drivers",
      impoExpo: "Import/Export drivers",
      binational: "Binational drivers",
      mechanics: "Mechanics",
      hazmat: "Hazmat material handlers",
    },
    filters: {
      dateFrom: "Exit - From",
      dateTo: "Exit - To",
      movementType: "Movement type",
      carrierCompany: "Carrier company",
      unitOrDriver: "Unit or driver",
      unitOrDriverPlaceholder: "Search by unit or driver",
    },
  },
  employees: 'Employees',
  welcomeTitle: "WELCOME!",
  welcomeMessage: "Welcome message",
  securityRules: "Security rules",
  securityRulesTitle: "GENERAL RULES FOR SAFETY, HYGIENE, AND ENVIRONMENT",
  securityRule1: "Smoking is prohibited inside the facility. Smoking is allowed only in designated area outside of the building.",
  securityRule2: "Wear a visible ID at all times within the facilities.",
  securityRule3: "Entering under the influence of alcohol, narcotics, or any substance that alters mental or sensory faculties is prohibited.",
  securityRule4: "Do not take photographs or videos inside the facilities without authorization from HSE or HR.",
  securityRule5: "Removing tools, materials, or equipment without authorization is prohibited.",
  securityRule6: "Respect and obey all safety signs.",
  securityRule7: "The minimum personal protective equipment (PPE) required is: safety shoes, safety glasses, earplugs, and a reflective vest (contractors/suppliers/visitors). Additional PPE may be required depending on the type of work.",
  securityRule8: "Visitors with health issues are not allowed.",
  securityRule9: "Visitors with disabilities are not allowed.",
  securityRule10: "Visitors with behavioral problems or those who do not meet the following requirements are not allowed:",
  goodPracticesTitle: "GOOD MANUFACTURING PRACTICES AND DRESS CODE",
  goodPractices1: "The use of inappropriate clothing such as sleeveless tops, low-cut shirts, shorts, or ripped/torn pants is prohibited. Pants must fully cover the legs.",
  goodPractices2: "The use of open-toe or high-heeled shoes in operational areas is prohibited.",
  goodPractices3: "Food and beverages may only be consumed in designated areas.",
  goodPractices4: "Keep the work area clean and organized.",
  goodPractices5: "Keep hair short or tied back, and do not wear chains, rings, bracelets, or other objects that could get caught in operational areas.",
  prohibitedItemsTitle: "PROHIBITED ITEMS",
  prohibitedItems1: "Alcoholic beverages.",
  prohibitedItems2: "Narcotics or controlled substances.",
  prohibitedItems3: "Explosives.",
  prohibitedItems4: "Cigarettes or tobacco products.",
  prohibitedItems5: "Firearms or ammunition.",
  prohibitedItems6: "Cameras or video devices without authorization.",
  prohibitedItems7: "Hazardous materials without a Safety Data Sheet and HSE authorization.",
  prohibitedItems8: "Removable blades.",
  prohibitedItems9: "Internal combustion engines without approved emission control.",
  close: "Close",
  vendors: "Vendors",
  employees: "Employees",
  visitants: "Visitants",
  visitant_email: "Visitor Email",
  visitant_phone: "Visitor Phone",
  drag_file: "Drag and drop the file here",
  back: "Back",
  usernameOrEmail: "Username or Email",
  password: "Password",
  rememberMe: "Remember Me",
  forgotpassword: "Did you forget your password?",
  login: "Sign In",
  vendorsAccess: "Vendors Access",
  employeesAccess: "Employees Access",
  visitantsAccess: "Visitants Access",
  carriersAccess: "Carriers Access",
  home: "Home",
  welcomeTo: "Welcome to",
    tracto: 'Tractor',
    tractos: 'Tractors',
  resumeTwoDays: "Resume of the last two days",
  toDate: "To Date",
  rounds: "Rounds",
  findingsInTransit: "Findings in Transit",
  findingsOnPatrol: "Findings on Patrol",
  incidents: "Incidents",
  incident: "Incident",
  findings: "Findings",
  reports: "Reports",
  monthlyIncidentsReport: "Monthly incidents report",
  selectMonth: "Select Month",
  startDate: "Start Date",
  endDate: "End Date",
  month: "Month",
  year: "Year",
  download: "Download",
  unableToLoadReport: "Unable to load report",
  selectRound: "Select Round",
  checkListReport: "Check list report",
  all: "All",
  positive: "Positive",
  neutral: "Neutral",
  negative: "Negative",
  roundLogReport: "Round log report",
  onlyCompleted: "Only completed",
  onlyUncompleted: "Only uncompleted",
  onlyWithoutExecuted: "Only without finished",
  opened: "Opened",
  closed: "Closed",
  roundRoute: "Round Route",
  tags: "Tags",
  tag: "Tag",
  tasks: "Tasks",
  users: "Users",
  administration: "Administration",
  menuPermissions: "Permissions",
  roles: "Roles",
  search: "Search",
  export: "Export",
  exportCSV: "Export CSV",
  exportPDF: "Export PDF",
  finishedRounds: "Finished Rounds",
  OnGoingRounds: "On Going Rounds",
  route: "Route",
  realizedBy: "Realized By",
  occurred: "Occurred",
  finished: "Finalized",
  duration: "Duration",
  accomplishment: "Accomplishment",
  view: "View",
  noRecordsFound: "No records found",
  of: "of",
  patrols: "Patrols",
  rejectAccessRequestTitle: "Reject Access Request",
  writeTheRejectReason: "Write the reason of the rejection",
  accessrequests: "Access Requests",
  newAccessRequest: "New Access Request",
  accessLog: "Access Log",
  accessvip: "Access VIP",
  accesslogvip: "Access Log VIP",
  Accesses: "Accesses",
  accountDetails: "Account Details",
  id: "ID",
  name: "Name",
  lastname: "Lastname",
  username: "Username",
  email: "Email",
  mobile: "Mobile",
  accountEdit: "Account Edit",
  changePassword: "Change Password",
  loading: "Loading...",
  report: "Report",
  enterName: "Enter Name",
  oldpassword: "Current Password",
  newpassword: "New Password",
  confirmpassword: "Confirm Password",
  profileImage: "Profile Image",
  enterLastname: "Enter Lastname",
  enterUsername: "Enter Username",
  enterEmail: "Enter Email",
  enterMobile: "Enter Mobile",
  requestCannotBeCompleted: "Request cannot be completed",
  all_rights_reserved: "All rights reserved",
  myAccount: "My Account",
  logout: "Logout",
  welcome: "Welcome!",
  accesslog: "Access Log",
  actions: "Actions",
  downloadPDF: "Download PDF",
  addNew: "Add New",
  enterLabel: "Enter Label",
  send: "Send",
  edit: "Edit",
  delete: "Delete",
  update: "Update",
  requester: "Requester",
  select_a_value: "Select a value",
  vendor: "Vendor",
  carrierCompany: "Carrier Company",
  carrierCompanies: "Carrier Companies",
  newCarrierCompany: "New Carrier Company",
  editCarrierCompany: "Edit Carrier Company",
  viewCarrierCompany: "View Carrier Company",
  subject: "Subject",
  enterSubject: "Enter Subject",
  visitMessageRequest: "This access is exclusively for visitors. Engaging in operational activities, such as construction, site work, maintenance, or material delivery, is strictly prohibited under this permit.",
  visit_to: "Visit to",
  scheduledVisitDate: "Scheduled Visit Date",
  identification: "Identification",
  documentation: "Documentation",
  employee: "Employee",
  fullNameVisitor: "Full Name Visitor",
  visitor: "Visitor",
  enterPhone: "Enter Phone",
  status: "Status",
  priority: "Priority",
  addAccessrequest: "Add Access Request",
  expirationDate: "Expiration Date",
  exitTime: "Exit Date and Time",
  kanban: "Kanban",
  newRequest: "New Request",
  requests: "Requests",
  accessRequestStatus: "Access Request Status",
  date: "Date",
  selectDate: "Select date",
  dateRange: "Date range",
  visit_time: "Visit Time",
  comment: "Comment",
  documentationQ: "Documentation?",
  noRequireRevision: "No revision\nrequired",
  documentationCorrect: "Documentation\ncorrect",
  requireRevision: "Revision\nrequired",
  acceptedQ: "Accepted?",
  yes: "Yes",
  no: "No",
  Documentación: "Documentation",
  Validación: "Validation",
  Rechazado: "Rejected",
  Aceptado: "Acepted",
  Completado: "Completed",
  Invitado: "Guest",
  add: "Add",
  host: "Host",
  enterCompany: "Enter Company",
  select_date: "Select Date",
  taxId: "Tax ID",
  vendorStatus: "Vendor Status",
  repse: "REPSE",
  address: "Address",
  requesterDetails: "Requester Details",
  deleteRecord: "Delete Record",
  confirmRecordDeletion: "Are you sure you want to delete this record?",
  confirmAcceptVisit: "Are you sure you want to accept this visit?",
  acceptVisit: "Accept Visit",
  acceptedSuccessfully: "Accepted Successfully",
  rejectVisit: "Reject visit",
  rejectionReason: "Rejection reason",
  confirmRejectVisit: "Are you sure you want to accept this visit?",
  rejectedSuccessfully: "Rejected Successfully",
  date_hour: "Date and Hour",
  dateCreated: 'Date Created',
  type: "Type",
  securityGuard: "Security Guard",
  accessNotes: "Access Notes",
  records: "Records",
  notes: "Notes",
  gaveAccess: "Gave Access",
  images: "Images",
  qrCode: "QR Code",
  viewQr: "View QR",
  notAvailable: "Not Available",
  enterTaxId: "Enter Tax ID",
  checking: "Checking...",
  enterAddress: "Enter Address",
  formsRequired: "Forms Required",
  formValidationError: "Form Validation Error",
  formValidationMsg: "Please complete the form",
  createRecord: "Create Record",
  createRecordSuccess: "Record created successfully",
  category: "Category",
  updateRecord: "Update Record",
  updateSuccess: "Record updated successfully",
  bitacora: "Control log",
  select_a_status: "Select a status",
  nss: "SSN",
  enterNss: "Enter SSN",
  employeeDetails: "Employee Details",
  forms: "Forms",
  writeHere: "Write here",
  carrier: "Carriers",
  carrierrequests: "Carrier Access Requests",
  carriersAreas: "Carrier Areas",
  carriersReceipt: "Receipt Dashboard",
  carriersYard: "Yard Dashboard",
  carriersShipping: "Shipping Dashboard",
  receiptAreaSubtitle: "Carrier management in receipt area",
  yardAreaSubtitle: "Carrier management in yard area",
  shippingAreaSubtitle: "Carrier management in shipping area",
  goBack: "Go back",
  refreshData: "Refresh data",
  refresh: "Refresh",
  rampsDashboards: "Ramps Dashboards",
  carrier_accesslog: "Carrier Access Log",
  rampsScreen: "Ramps Screen",
  settings: "Settings",
  vendorsCategories: "Vendors Categories",
  departments: "Departments",
  statusRequests: "Status of Requests",
  priorities: "Priorities",
  statusUsers: "Status of Users",
  statusVendors: "Status of Vendors",
  statusRepse: "Status of REPSE",
  print: "Print",
  pdf: "PDF",
  excel: "Excel",
  csv: "CSV",
  historyChanges: "History of Changes",
  noAuditsRecords: "No audit records found",
  change: "Change",
  unknown: "Unknown",
  inProgress: "In Progress",
  created: "Created",
  updated: "Updated",
  deleted: "Deleted",
  event: "Event",
  findingReport: "Finding Report",
  findingType: "Finding Type",
  inTransit: "In Transit",
  onPatrol: "On Patrol",
  updating: "Updating...",
  changeToClosed: "Change to Closed",
  changeToOpened: "Change to Opened",
  reportedBy: "Reported By",
  description: "Description",
  noImagesAttached: "No images attached",
  finishedAt: "Finished At",
  round: "Round",
  duration: "Duration",
  tagsCompleted: "Tags Completed",
  successFinished: "Finished successfully",
  earlyFinished: "Finished early",
  notFinished: "Not finished",
  folio: "Folio",
  doneBy: "Done By",
  hour: "Hour",
  comments: "Comments",
  user: "User",
  addComment: "Add Comment",
  area: "Area",
  responsableOfService: "Responsable of Service",
  itWasReported: "It was reported",
  severity: "Severity",
  shortDescription: "Short Description",
  incidentReport: "Incident Report",
  reportDate: "Report Date",
  ocurrenceDate: "Ocurrence Date",
  reportedBy: "Reported By",
  deleteSelected: "Delete Selected",
  addTag: "Add Tag",
  latitude: "Latitude",
  longitude: "Longitude",
  altitude: "Altitude",
  selectLocation: "Select Location",
  location: "Location",
  drag_marker: "Drag the marker to change the location",
  subcategory: "Subcategory",
  group: "Group",
  keyword: "Keyword",
  task: "Task",
  enterPassword: "Enter Password",
  confirmPassword: "Confirm Password",
  department: "Department",
  role: "Role",
  securityRulesHeader: "Security Rules",
  scrollToAcceptSecurityRules: "Scroll to the end to enable acceptance.",
  errorLoadingPdf: "Unable to load the PDF.",
  welcomeVip: "WELCOME",
  seeYouSoonVip: "SEE YOU SOON",
  accessQrCodeQuestion: "Do you want to register access of this QR code?",
  accessQrCodeError: "Error registering access",
  cameraNotFound: "Camera not found",
  cameraNotAccess: "Camera not access",
  toggleCamera: "Toggle Camera",
  confirm: "Confirm",
  appPatrol: "Patrol App",
  appGuard: "Guard App",
  appCarrier: "Kiosko App",
  modulePatrol: "Patrol Dashboard",
  moduleGuard: "Guard Dashboard",
  moduleCarrier: "Carrier Dashboard",
  patrol: "Patrols",
  guard: "Guard",
  accessInsideBuilding: "Access Inside Building",
  requestsToApprove: "Requests to Approve",
  vendorRequestsToApprove: "Vendor Requests to apprve",
  approvedRequests: "Requests Accepted",
  vendorsList: "Vendors Directory",
  monthlyRequests: "Monthly Requests",
  exporting: "Exporting...",
  findingOnPatrol: "Findings on Patrol",
  findingInTransit: "Findings in Transit",
  occurrenceDate: "Occurrence Date",
  quizTitle: "Quiz",
  answerQuiz: "Answer Quiz",
  notProhibited1: "Food and Beverage",
  notProhibited2: "Celphone and electronic devices",
  notGoodPractices1: "Inappropriate and casual clothing",
  question1: 'What is the first security rule?',
  question2: 'What item is prohibited?',
  question3: 'What is not a good practice?',
  errorQuiz: 'Answer at least 2 correctly to continue.',
  vehicles: "Vehicles",
  plates: "Plates",
  model: "Model",
  circulation_card: "Circulation Card",
  vehicle_secure: "Car insurance",
  enterPlates: "Enter Plates",
  enterModel: "Enter Model",
  select_year: "Select Year",
  fk_vendor: "Vendor",
  vehicle: "Vehicle",
  tools: "Tools",
  computers: "Computers",
  serial_number: "Serial Number",
  enterSerialNumber: "Enter Serial Number",
  computer_equipment: "Computer Equipment",
  employee_name: "Employee Name",
  driverLicense: "Driver License",
  enterDriverLicense: "Enter License Number",
	employee_number: "No. Empleado",
  categoryServiceMessage: "If the employee category is Contractor you will upload the files of *Insurance* as well as a vigent *Security and Hygiene Course* and *Patrimonial Course*.",
  categoryContractorMessage: "If the employee category is Specialized Services you will upload the files of *Insurance* and *ISO 14001* as well as a vigent *Security and Hygiene Course* and *Patrimonial Course*.",
  categoryVendorMessage: "If the vendor category is Vendor you don't need to upload any file.",
  computer_id: "Computers",
  tools_id: "Tools",
  image: "Image",
  photo: "Photo",
  photoUploadHint: "Click to select the photo",
  captcha_advisement: 'Verify that you are not a robot. Robots cannot access the plant.',
  captcha_expiration_advisement: 'After validating the captcha you have 5 minutes to make the request for visit.',
  privacyNotice: "Privacy Notice",
  securityRules: "Security Rules",
  youMustAcceptPrivacyNotice: "You must accept and read carefully the privacy notice to be in agreement with the security rules as well as the use of your personal information.",
  youMustAcceptSecurityRules: "You must accept and read carefully the security rules.",
  acceptAndContinue: "Accept and continue",
  employeeExpiredCoursesMessage: "The employee has expired courses and must not access the facility.",
  areYouAForeigner: "Are you a foreigner?",
  carrierrequests: "Carrier Access Requests List",
  newCarrierAccessRequest: "New Carrier Access Request",
  accessType: "Access type",
  files: "Files",
  requestDate: "Request date",
  date: "Date",
  switchLanguage: "Switch language",
  FM3RequiredToAccess: "You will be required to present your FM-3 in order to attend the visit",
  other: "Other",
  package_delivery: "Package delivery",
  valuable_delivery: "Valuable delivery",
  employee_no_credential: "Employee without credential",
  staff_visit_exit: "Exit for visits / meals",
  unregistered_overtime: "Unregistered overtime",
  vehicle_entry_exit: "Vehicle entry/exit",
  guest: "Guest",
  before: "Before",
  after: "After",
  empty: "Empty",
  audits: {
    label: "Audits",
    descriptions: {
      employee: "The user ${userName} ${eventName} an employee named ${employeeName}",
      employeeForm: "The user ${userName} ${eventName} a form field submission of ${formName} associated to ${employeeName}",
      vendor: "The user ${userName} ${eventName} a vendor named ${vendorName}",
      vehicle: "The user ${userName} ${eventName} a vehicle model ${vehicleModel} from ${vehicleYear}",
      tool: "The user ${userName} ${eventName} a tool named ${toolName}",
      computer: "The user ${userName} ${eventName} a computer model ${computerModel} serial ${computerSerialNumber}",
      task: "The user ${userName} ${eventName} a task named ${taskName}",
      tag: "The user ${userName} ${eventName} a tag named ${tagName}",
      patrol: "The user ${userName} ${eventName} a round route named ${patrolName}",
      incident: "The user ${userName} ${eventName} an incident with the folio ${folio} in ${area} with description '${shortDescription}'",
      finding: "The user ${userName} ${eventName} a finding with the folio ${folio} with description ${description}",
      findingWithTask: "The user ${userName} ${eventName} a finding with the folio ${folio} for the task ${task} with description ${description}",
      round: "The user ${userName} ${eventName} a round with the folio ${folio} for the route ${patrolName}",
      accessRequest: "The user ${userName} ${eventName} an access request of the type ${accessType}. ${contactName} from ${companyName} visits ${visitTo}",
			box: "The user ${userName} ${eventName} a container of type ${containerType} with box number ${boxNumber}",
			carrierVehicle: "The user ${userName} ${eventName} a carrier with unit number ${unitNumber}",
			carrierRequest: "The user ${userName} ${eventName} a carrier access request for the company ${vendorName} scheduled to ${date}",
			carrierExport: "The user ${userName} ${eventName} a carrier export request for the container ${boxNumber}",
			carrierImport: "The user ${userName} ${eventName} a carrier import request for the container ${boxNumber}",
    },
    events: {
      created: "created",
      updated: "updated",
      deleted: "deleted",
      restored: "restored",
    },
  },
  action: "Action",
  form: "Form",
  formField: "Form field",
  employeeForms: "Employee forms",
  response: "Response",
  formSubmission: "Form submission",
  employeeCategories: "Employee categories",
  employeeCategory: "Employee category",
  tool: "Tool",
  involvedPeople: "Involved people",
  start: "Start",
  end: "End",
  completionPercentage: "Completion percentage",
  acceptCarrierRequest: "Accept carrier request",
  rejectCarrierRequest: "Reject carrier request",
  box: "Container",
  box_number: "Box number",
  eco_box_1: "Economic of carrier box 1",
  eco_box_2: "Economic of carrier box 2",
  seals: "Seals",
  emailTovisit: "Host's email",
  bill: "Bill",
  purchaseOrder: "Purchase Order",
  letterContribute: "Letter of Contribute",
  isForeigner: "Is foreigner",
  badge: "Badge",
  vehicleInformation: "Vehicle information",
  accessRequest: "Access request",
  employeeForm: "Employee form",
  finding: "Finding",
  acceptedSecurityRules: "Understood the security rules",
  grantAll: "Grant all",
  revokeAll: "Revoke all",
  searchPermissions: "Search permissions",
  addNewPermission: "Add New",
  update: "Update",
  permission: "Permission",
  permissionsList: "Permissions List",
  path: "Path",
	modules: {
		access_log: "Access log",
		access_requests: "Access requests",
		carrier_requests: "Carrier requests",
		carrier_log: "Carrier log",
		access_vip: "Access VIP",
		vendors: "Vendors",
		patrol: "Patrol",
		administration: "Administration",
	},
  role: "Role",
  permissions: {
    index: "List",
    add: "Add",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    importdata: "Import data",
    cardlist1: "Cardlist 1",
    cardlist2: "Cardlist 2",
    cardlist3: "Cardlist 3",
    cardlist4: "Cardlist 4",
    accept_visit: "Accept visit",
    reject_visit: "Reject visit",
    getdata: "Get information",
    rejected: "Rejected",
    guard: "Guard",
    accept_carrier: "Accept carrier",
    reject_carrier: "Reject carrier",
    "exit-ramp": "Exit ramp",
    "update-status": "Update status",

    // Probably one of these two isn’t used. See which one it is and delete it from the db and from here
    "dashboard-index": "Dashboard",
    "dashboards-index": "Dashboard",

    "screen-index": "Screen",
    route: "Route",
    tasks: "Tasks",
    checklist: "Checklist",
    finishtag: "Finish tag",
    log: "Log",
    togglepause: "Pause",
    finishround: "Finish round",
    areas: "Areas",
    categories: "Categories",
    departments: "Departments",
    status: "Status",
    storage: "Storage",
    download: "Download",
    download_incidents: "Download incidents",
    patrol: "Patrol",
    list: "List", // TODO: Remove this endpoint, it's redundant after the permissions rework
  },
	Inspection:{
		singular: "Inspections",
		plural: "Inspections",
		requestId: "Request ID",
		driverName: "Driver name",
		company: "Company",
		movement: "Movement",
		vehicleType: "Vehicle type",
		unit: "Unit",
		start: "Started at",
		end: "Ended at",
		guard: "Guard",
		result: "Inspection status",
		box_number: "Box number"
	},
  driver: "Driver",
  carrierEconomic: "Economic of carrier trailer",
  boxEconomic: "Economic of carrier box",
  documents: "Documents",
	affiliation: "Affiliation",
	unitNumber: "Unit number",
  assetCheckouts: {
    title: "Asset checkout",
    status: {
      exited: "Exited",
      waitingAuth: "Pending authorization",
      notExited: "Not exited",
      cannotReturn: "Awaiting authorization/exit",
      awaitingExit: "Awaiting exit",
      pendingReturn: "Pending return",
    },
		dashboardTitle: "Asset checkouts dashboard",
		dashboardSubtitle: "Key indicators for assets leaving the site",
		viewList: "View list",
		airlifeAssignments: "Airlife assignments",
		recentActiveTitle: "Active checkouts",
		recentActiveSubtitle: "Latest exits with items still outside",
		type: "Checkout type",
		types: {
			loan: "Loan",
			repair: "Repair",
			owner: "Product's owner",
			supplier_sample: "Supplier sample",
			donation: "Donation",
			sale: "Sale",
			return: "Return",
		},
		exitTime: "Exit Date and Time",
		company: "Company",
    employee: "Employee",
    assets: "Assets",
    asset: "Asset",
    partNumber: "Part number",
    authorizers: {
      product_owner: "Product owner",
      authorizer: "Authorizer",
      customs: "Customs",
      patrimonial_security: "Patrimonial security",
      maintenance_superintendent: "Maintenance Superintendent",
      safety_hygiene: "Safety & Hygiene",
      finance: "Finance",
    },
		metrics: {
			active: "Active checkouts",
			activeHelper: "With items outside the site",
			checkoutByType: "Checkouts by type",
			checkoutByTypeHelper: "Breakdown of active checkout types",
			itemsOut: "Items outside",
			itemsOutHelper: "Assets not yet returned",
      airlifeActive: "Assets with Airlife employees",
			airlifeHelper: "Internal personnel checkouts",
      vendorActive: "Assets with vendor employees",
      vendorHelper: "External/vendor checkouts",
			pendingAuth: "Pending authorization",
			pendingHelper: "Awaiting authorizers before exit",
			vendorExits: "Active third-party exit passes",
			vendorExitsHelper: "Listed by exit pass vendor",
		overdue: "Overdue",
		overdueHelper: "Expired with items outside",
		expiringHelper: "Expiring soon (3 days)",
		total: "Total checkouts",
			totalHelper: "All asset checkouts",
			outstanding: "Items outside",
		},
	},
	return: "Return",
	returned: "Returned",
	pendingReturn: "Pending Return",
	returnedAt: "Returned at",
	signature: "Signature",
	turn: "Turn",
	picture: "Picture",
	document: "Document",
	changeSignature: "Change signature",
	boxNumber: "Container number",
	measures: "Measures",
	currentSeal: "Latest sealing",
	sealHistory: "Sealing history",
	noSealHistoryFound: "No sealing history found for this container",
  boxes: "Containers",
  economics: "Economics",
  economicNumber: "Economic",
	boxEconomics: "Box economics",
	carrierEconomics: "Carrier economics",
	twoMovements: "Two movements?",
	movements: "Movements",
  firstMovement: "First movement",
	secondMovement: "Second movement",
	productOwner: "Product owner",
	productOwnerEmail: "Product owner email",
	authorizer: "Authorizer",
	patrimonialSecurity: "Patrimonial security",
	customs: "Customs",
	maintenanceSuperintendent: "Maintenance Superintendent",
	safetyHygiene: "Safety & Hygiene",
	finance: "Finance",
	authorization: "Authorization",
	requester: "Requester",
	authorize: "Authorize",
	deny: "Deny",
	denyAuthorization: "Deny Authorization",
	denyReason: "Reason for denial",
	enterDenyReason: "Enter the reason to deny this authorization...",
	confirmAuthorization: "Confirm Authorization",
	confirmAuthorizeMessage: "Are you sure you want to authorize this asset checkout?",
	confirm: "Confirm",
  pending: "Pending",
  authorized: "Authorized",
  denied: "Denied",
  exit: "Exit",
  return: "Return",
	sku: "SKU",
	partNumber: "Part Number",
	title: "Title",
	// Carriers - Imports & Exports
	carriersImports: "Imports",
	carriersExports: "Exports",
	importsSubtitle: "Imports management",
	exportsSubtitle: "Exports management",
	importsList: "Imports List",
	exportsList: "Exports List",
	olderDay: "Previous day",
	newerDay: "Next day",
	pickDate: "Go to date",
	containerNumber: "Container Number",
	searchByContainer: "Search by container",
	export: "Export",
	exportCSV: "Export CSV",
	exportPDF: "Export PDF",
	exportToExcel: "Export to Excel",
	filters: "Filters",
	clearFilters: "Clear Filters",
	filtered: "Filtered",
	from: "From",
	to: "To",
	// Imports columns
	yardaOrigen: "Origin Yard",
	container: "Container",
	tractorNumber: "Tractor Number",
	driver: "Driver",
	platesUSAMX: "Plates USA/MX",
	fechaSalidaYarda: "Yard Exit Date",
	horaSalidaYarda: "Yard Exit Time",
	cruceMexicana: "Arrival at U.S. Customs",
	salidaAduanaMexicana: "Mexican Customs Exit",
	carreteraAeropuerto: "Highway/Airport",
	llegadaPlanta: "Plant Arrival",
	numeroCandado: "Lock Number",
	numeroSello: "Seal Number",
	numeroSelloRojo: "Red Seal Number",
	destinoFinal: "Final Destination",
	// Exports columns
	hora: "Time",
	contenedor: "Container",
	numTractor: "Tractor No.",
	chofer: "Driver",
	transportista: "Carrier",
	salidaPlanta: "Plant Exit",
	cruzandoUSA: "Crossing USA",
	llegadaYarda: "Yard Arrival",
	descargadoYarda: "Unloaded at Yard",
	retornoSP: "Return W/O",
	llegadaSanIsidro: "San Isidro Arrival",
	carreteraRetornoSPUSA: "Highway Return W/O USA",
	salidaAduanaUSA: "USA Customs Exit",
	enPlantaLleno: "At Plant Full",
	cargadoEnPlanta: "Loaded at Plant",
	inspeccionVacio: "Empty Inspection",
	recibidoSinContenedor: "Received Without Container",
	listoCarga: "Ready to Load",
	turnoCarga: "Loading Shift",
	candado: "Lock",
	sello: "Seal",
  boxLogs: "Box logs",
  sealLogs: "Sealing logs",
  carrierRequestLogbook: "Carrier request logbook",
  logId: "Log ID",
  carrierRequestIdLabel: "Request ID",
  dateTime: "Date / Time",
  dateRange: "Date range",
  searchPlaceholder: "Search...",
  eventDescription: "Event description",
  recordsRange: "Records ${from} - ${to} of ${total}",
        carrierStatus: {
          requested: "Requested",
          accepted: "Accepted",
          rejected: "Rejected",
          inspected: "Inspected",
                "in-progress": "In progress",
                sealed: "Sealed",
                finished: "Finished",
        },
        // Document statuses
        documentStatuses: {
                valid: "Current",
                warning: "Expiring soon",
                danger: "About to expire",
                expired: "Expired",
        },
        documentsTotalLabel: "Total",
        documentsEmpty: "No documents registered",
        documentsSection: "Documents",
        expandDocuments: "Expand",
        collapseDocuments: "Collapse",
        documentFieldTypes: {
                file: "File",
                image: "Image",
                text: "Text",
        },
        documentExpiredDays: {
                expired: "Expired %d days ago",
                expiredToday: "Expires today",
                expiredTomorrow: "Expires tomorrow",
                expiredIn: "Expires in %d days",
                expiredInMonths: "Expires in %d months",
        },
        employeeCategories: "Category",
        employeeCompany: "Company",
        // Carrier requests view labels
        requestDate: "Request Date",
        requestStatus: "Status",
        vehicleType: "Vehicle Type",
        unitNumber: "Unit Number",
        platesUSA: "USA Plates",
        platesMX: "MX Plates",
        driverName: "Name",
        driverLicenseLabel: "Driver License",
        driverCategory: "Category",
        driverPhoto: "Photo",
        noPhoto: "No photo",
        driverData: "Driver Data",
        tractData: "Tractor Data",
        requesterData: "Requester Data",
        movements: "Movements",
        firstMovement: "First Movement",
        secondMovement: "Second Movement",
        userData: "Username",
        userFirstNames: "First Names",
        userLastName: "Last Name",
        userEmail: "Email",
        userPhone: "Phone",
        timeline: "Timeline",
        boxMovement: "Container movement",
        containerPickup: "Container picked up",
        containerDelivery: "Container delivered",
        seeImage: "See image",
        viewSealing: "View sealing",
        sealingDetails: "Sealing details",
        sealingPhotos: "Sealing photos",
        signatures: "Signatures",
        notAvailable: "N/A",
        noSignature: "No signature",
        sealedAt: "Sealed at",
        sealedBy: "Sealed by",
        vvttLabel: "VVTT",
        finalObservations: "Final observations",
        doorsClosed: "Doors closed",
        doorsOpen: "Doors open",
        sealPlacement: "Seal placement",
        bottleSeal: "Bottle seal",
        chicoteSeal: "Chicote seal",
        redSeal: "Red seal",
        doorsClosedWithSeal: "Doors closed with seal",
        signatureDriver: "Driver signature",
        signatureSealer: "Sealer signature",
        signatureGuard: "Guard signature",
        noSealingFound: "No sealing found",
        noLogsFound: "No logs found",
        carrierRequestDetail: "Request Detail",
        deleteRecord: "Delete record",
        confirmRecordDeletion: "Are you sure you want to delete this record?",
        recordDeletedSuccessfully: "Record deleted successfully",
        transportista: "Carrier",
        currentSeal: "Latest sealing",
        deleteSelected: "Delete Selected",
        noSealAssigned: "No sealing registered",
        requiredDocuments: "Required Documents",
        completeDocumentationInfo: "Complete the information of the documents required for this carrier category.",
        futureDate: "Future date required",
        loadingDocuments: "Loading required documents...",
        documentsLoaded: "Documents Loaded",
        noDocumentsFound: "No documents found for this category",
        errorLoadingDocuments: "Error Loading Documents",
        unexpectedServerResponse: "The employee was updated but the server response was unexpected",
        departmentUsers: "Department Users",
        usersInDepartment: "Users in this department",
        noUsersInDepartment: "No users in this department",
        usersDepartment: "Departments",
        expandUsers: "View users",
        collapseUsers: "Hide users",
        totalUsersInDepartment: "Total users",
        userActive: "Active user",
        userInactive: "Inactive user",
        archiveRecords: "Records",
        isLoadedLabel: "Vehicle loaded?",
        isLoadedYes: "Yes (Loaded)",
        isLoadedNo: "No (Empty)",
        isLoadedHint: "Only applies for trailer in import or local entry.",
        isExportLabel: "Is empty box exit an export?",
        isExportYes: "Yes (Export)",
        isExportNo: "No (Domestic)",
        isExportHint: "Only applies when the second movement is empty box exit.",
        twoMovementsLabel: "Schedule later exit",
        twoMovementsHint: "Enable if there will be a second exit movement.",
        entranceMovementHint: "Entrance movements are only selected here.",
        exitMovementHint: "Exit movements are only selected here.",
        selectMovement: "Select a movement",
	carrierDataTitle: "Carrier Information",
	carrierDataSubtitle: "Company, operator and unit to validate access.",
	movementsDataTitle: "Movements and Load",
	movementsDataSubtitle: "The first movement defines the inspection checklist.",
	schedulingTitle: "Scheduling",
	schedulingSubtitle: "Select available date and request status.",
	step1: "Step 1",
	step2: "Step 2",
	step3: "Step 3",
	solicitante: "Applicant",
	carrierCompanyPlaceholder: "Select a carrier company",
	companyDefinesOperators: "The company defines the catalog of operators and units.",
	selectCompanyFirst: "First select a carrier company",
	selectVehicleFirst: "First select a vehicle",
	driverResponsible: "Select the operator responsible for the unit.",
	vehicleTypeHint: "The vehicle type defines the inspection points.",
	containerFirstMovement: "Container assigned to the first movement.",
	containerSecondMovement: "Container assigned to the second movement.",
	selectOption: "Select an option",
	loadingAvailability: "Loading availability...",
	scheduledCarrierDate: "Scheduled carrier date",
	available: "Available",
	limited: "Limited",
	unavailable: "Unavailable",
	statusHint: "Defines the initial state of the request.",
	confirmVisitDate: "Confirm the scheduled visit date.",
	adjustVisitDate: "Adjust visit date and request status.",
	
	// Employee No Credential Translations
	employeeInfo: "Employee Information",
	employeeNumber: "Employee Number",
	area: "Area",
	supervisor: "Supervisor",
	badgeNumber: "Badge Number",
	deliveryTime: "Delivery Time",
	motivo: "Reason",
	accessNotes: "Access Notes",
  fields: "Fields",
  required: "Required",
  generalInformation: "General information",
  noFormFieldsMessage: "There's no form fields. Click 'add' to add a new one.",
  fieldDescription: "Fiel description",
  file: "File",
  confirmDeletion: "Confirm deletion",
  formFieldConfirmDeletionMessage: "Are you sure you want to delete the field '${fieldName}'?",
	accessRequest: "Access request",
  sealOne: "Número de sello 1",
  sealTwo: "Número de sello 1",
	carrierExport: "Exports",
	carrierImport: "Imports",
  lastModifiedBy: "Last modified by",
  noChangesMadeYet: "No modification history found",
  finishedFilter: "Finished",
  notFinishedFilter: "No finished",
  comentarioRetorno: "Return comment",
  comentarioRetorno: "Return comment",
  enterComment: "Enter comment",
  loaded: "Loaded",
  key: "Key",
  value: "Value",
	settingsJsonTip: "Tip: Use plain text or valid JSON",
	freeYardSpace: "Free space",
	occupyYardSpace: "Occupy space",
	giveBoxToCarrier: "Give container to carrier",
	pickUpBoxFromCarrier: "Pick up container from carrier",
	currentBox: "Current container",
	pickUp: "Pick up",
	give: "Give",
  module: "Module",
};
